import {Component, OnInit} from "@angular/core";
import {AppConfigService} from "../../config/app-config.service";
import {TranslateService} from "../../shared/translate.service";
import {AuthService} from "../../auth/auth.service";
import {DetectBrowserService} from "../../html-utils/detect-browser/detect-browser.service";
import {Browser} from "../../html-utils/detect-browser/browser";
import {ErrorComponent} from "./error/error.component";
import {ModeService} from "../../config/mode.service";

@Component({
  selector: 'app-server-error',
  templateUrl: './server-error.component.html',
  styleUrls: ['./server-error.component.scss']
})
export class ServerErrorComponent implements OnInit {


  errors: ErrorComponent [] = [];

  errorPanelVisible: boolean = false;

  constructor(private appConfig: AppConfigService,
              private translateService: TranslateService,
              private authService: AuthService,
              private detectBrowser: DetectBrowserService,
              private modeService: ModeService) {
  }

  ngOnInit() {
    this.findErrors();
  }

  private findErrors() {
    this.errors = [];
    this.appConfig.getIndexesStatus(false).subscribe(indexDTO => {
      if (indexDTO.indexes && indexDTO.indexes.length > 0) {
        this.errors.push(this.createError(this.translateService.translate('Server.error.index.missing') + ':\n' + indexDTO.indexes.join(", ")));
        this.isErrorVisible();
      }
    }, (error) => {
      this.errors.push(this.createError(this.translateService.translate('Server.error.index.configuration.missing')));
      this.isErrorVisible();
    });
    this.getBrowserSupportError();
    this.getModeError();
  }

  private getModeError() {
    this.modeService.isReadOnly().then((readonly) => {
      if (readonly) {
        this.errors.push(this.createError(this.translateService.translate('Application.mode.readonly')));
      }
    }).then(() => {
      this.isErrorVisible();
    });

  }

  getBrowserSupportError(): void {
    const browserSupported = this.detectBrowser.isBrowserCompatible() || this.detectBrowser.isMobile();
    if (!browserSupported) {
      if (!this.detectBrowser.isBrowserVersionSupported()) {
        let errorMessage = this.translateService.translate(this.detectBrowser.getErrorMessageKey()) + '<br>';
        errorMessage += this.createBrowserImg(this.detectBrowser.getBrowserObject());
        this.errors.push(this.createError(errorMessage));
        this.isErrorVisible();
      }
      else {
        let errorMessage = this.translateService.translate(this.detectBrowser.getErrorMessageKey()) + '<br>';
        for (let browser of this.detectBrowser.getSupportedBrowsers()) {
          errorMessage += this.createBrowserImg(browser);
        }
        this.errors.push(this.createError(errorMessage));
        this.isErrorVisible();
      }
    }
  }

  createBrowserImg(browser: Browser): string {
    return `<a href="${browser.browserUrl}"><img class="browser-icon" src="${browser.imgUrl}" 
    title="${
    this.translateService.translate('Browser.' + browser.browser) + ' '
    + this.translateService.translate('Browser.version') + ` ${browser.version}`}" class="browser-img"></a>`
  }

  public isErrorVisible($error?: ErrorComponent) {
    if ($error) {
      const error = this.errors.find(e => e.error === $error.error);
      error.errorVisible = false;
    }
    this.errorPanelVisible = this.errors && this.errors.find(e => e.errorVisible === true) !== undefined;

  }

  private createError(error: string, errorVisible?: boolean) {
    const errorObject = new ErrorComponent();
    errorObject.error = error;
    errorObject.errorVisible = errorVisible !== undefined ? errorVisible : true;
    return errorObject
  }

}
